import { api } from "@api/api";
import { AgreementPlan } from "@modules/agreementPlans/types";
import { AgreementPlanFormValues } from "@modules/agreementPlans/validations";

export async function createAgreementPlanService(data: AgreementPlanFormValues): Promise<AgreementPlan> {
  const { data: agreement } = await api.post<AgreementPlan>("v1/agreement_plans/", data);

  return agreement;
}
